// extracted by mini-css-extract-plugin
export default {"side-bar":"Sidebar_side-bar__6V6QJ","side-bar-active":"Sidebar_side-bar-active__h+gFe"};